import { Api } from "@gogovapps/core-service-client";
import AppSettings from "../config";

export const coreService = new Api({ baseUrl: AppSettings.GOGOV_BASE_API_URL }).core;
